import { Injectable } from '@angular/core';
import { Boat } from '../interfaces/boat';
import {
  AngularFireDatabase,
  AngularFireList,
  AngularFireObject,
} from '@angular/fire/compat/database';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BoatCrudService {

  refs: AngularFireList<any> | undefined;
  ref: AngularFireObject<any> | undefined;

  path: string;

  constructor(private db: AngularFireDatabase) {
    this.path = environment.name + '/boats/' ;
  }

  getOrganisation() : string | null {
    const company = JSON.parse(localStorage.getItem('company')!);
    if (company && typeof company.$key !== 'undefined') {
        return company.$key;
    }
    return null;
  }

  // Create Boat
  add(record: Boat) {
    this.refs = this.db.list( this.path );
    const item = {
      ...record
    }
    this.refs?.push( item );
  }
  // Fetch Single Boat Object
  get(id: string) {
    this.ref = this.db.object( this.path + id);
    return this.ref;
  }
  // Fetch Boats List
  getList() {
    this.refs = this.db.list( this.path );
    return this.refs;
  }
  // Update Boat Object
  update(record: Boat) {
    this.ref = this.db.object( this.path + record.$key);
   // console.log("P inside", record);
    let item : Partial<Boat>  = {
      ...record
    }
    delete item?.$key;
    this.ref?.update(item);
  }
  // Delete Boat Object
  delete(id: string) {
    this.ref = this.db.object( this.path + id);
    this.ref.remove();
  }
}